import { useEffect, useState } from 'react';
import { useUrlSearchParams } from 'use-url-search-params';
// import AppContentView from '@crema/components/AppContentView';
import AppContentView from '../../components/src/lib/AppContentView';
import generateRoutes from '../../helpers/src/RouteGenerator';
import { Layouts } from '../../components/src/lib/AppLayout';
import { useAuthUser } from '../../hooks/src/AuthHooks';
// import {
//   useLayoutActionsContext,
//   useLayoutContext,
// } from '../../context/src/LayoutContextProvider';
import { useLayoutActionsContext, useLayoutContext } from '../../context/src/AppContextProvider/LayoutContextProvider';
// import { useSidebarActionsContext } from '@crema/context/SidebarContextProvider';

import { useNavigate, useRoutes, useSearchParams } from 'react-router-dom';
import { RoutePermittedRole } from '../../constants/src/AppEnums';
import { useSidebarActionsContext } from '../../context/src/AppContextProvider/SidebarContextProvider';
import { AI_REVIEW_MENUS, getValueByLangKey, isAiReviewChannel } from '../../helpers/src';
import defaultRoutesConfig from '../Routers/DefaultRoutesConfig';
import { useAuthUserQuery } from '../../services/auth/src/react-query/useAuthUserQuery';
import { useAuthMenusQuery } from '@libs/services/auth/src/react-query/useAuthMenusQuery';
import Loading from '@libs/modules/src/lib/errorPages/Loading';
// import { RoutePermittedRole } from '@crema/constants/AppEnums';
// import { getValueByLangKey } from '@crema/helpers';
import { MenuIcons } from '@libs/components/src/lib/AppLayout/components/VerticalNav/MenuIcons';
import { ROUTES } from '@crema/constants/AppConst';
import { useJWTAuth } from '@crema/services/auth/JWTAuthProvider';

type LayoutProps = {
  appRouter: any;
};

const Layout = (props: LayoutProps) => {
  const { appRouter } = props;
  const { unAuthorizedStructure, authorizedStructure, anonymousStructure } = appRouter;
  const navigate = useNavigate();

  const { navStyle } = useLayoutContext();

  const { data: userAuthData, error, refreshData: refreshAuthUser } = useAuthUserQuery();

  const { user, isAuthenticated, isLoading } = useAuthUser();

  const { data: menus, error: authMenuError, refreshData: refreshAuthMenus } = useAuthMenusQuery();

  const { user: jwtUser } = useJWTAuth();
  // 서버 메뉴에 없어 「디자인 관리」 하위에 끼워 넣는다. 라우트 가드(DefaultLayout)도 같은 helper 를 본다.
  const showAiReviewMenus = isAiReviewChannel(jwtUser?.channel?.channelId);

  const { updateNavStyle } = useLayoutActionsContext();
  const { updateMenuStyle, setSidebarBgImage } = useSidebarActionsContext();
  const AppLayout = Layouts[navStyle];
  const [params] = useUrlSearchParams();
  const generatedRoutes = generateRoutes({
    isAuthenticated: isAuthenticated,
    userRole: user?.role,
    unAuthorizedStructure,
    authorizedStructure,
    anonymousStructure,
  });
  const routes = useRoutes(generatedRoutes);
  const [authRoutesConfig, setAuthRoutesConfig] = useState<any[]>();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout as string);
    if (params.menuStyle) updateMenuStyle(params.menuStyle as string);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, [params, setSidebarBgImage, updateNavStyle, updateMenuStyle]);

  const sorting = (a: any, b: any) => {
    if (a.position > b.position) return 1;
    if (a.position < b.position) return -1;
    return 0;
  };

  const getSubMenus = (parentId: any) => {
    // @ts-ignore
    const subMenus = menus.filter(
      (menu) => menu.path.includes('.') && parseInt(menu.path.split('.')[0]) === parseInt(parentId),
    );
    subMenus.sort(sorting);
    return subMenus.map((menu) => {
      return {
        id: menu.id,
        title: getValueByLangKey(menu.localizedNames),
        messageId: '',
        type: 'item',
        permittedRole: [RoutePermittedRole.Admin, RoutePermittedRole.User],
        url: menu.url,
      };
    });
  };

  useEffect(() => {
    // query 에서 fullsize 파라미터 변경 시 cookie 에도 저장 하고 이후론 쿠키 값을 참고 하여 랜더링 한다.
    const fullsizeParam = searchParams.get('fullsize');
    if (fullsizeParam === 'true') {
      sessionStorage.setItem('fullsize', 'true');
    } else if (fullsizeParam === 'false') {
      sessionStorage.removeItem('fullsize');
    }
  }, [searchParams]);

  useEffect(() => {
    if (menus && menus.length) {
      // console.log('조회된 권한 메뉴들 ', menus);
      // console.log('이동하려는 url ', location.href);

      const parentMenus = menus.filter((menu) => !menu.path.includes('.'));
      parentMenus.sort(sorting);
      const newRouteConfigs = parentMenus.map((menu) => {
        const subMenus = getSubMenus(menu.id);
        if (menu.url === '/designs' && showAiReviewMenus) {
          AI_REVIEW_MENUS.forEach((extra) => {
            subMenus.push({
              id: extra.id,
              title: extra.title,
              messageId: '',
              type: 'item',
              permittedRole: [RoutePermittedRole.Admin, RoutePermittedRole.User],
              url: extra.url,
            });
          });
        }
        return {
          id: menu.id,
          title: getValueByLangKey(menu.localizedNames),
          messageId: '',
          type: 'collapse',
          children: subMenus,
          icon: MenuIcons[menu.url] || null,
          ...(subMenus.length === 0 && { url: menu.url }),
        };
      });
      setAuthRoutesConfig(newRouteConfigs);
    } else {
      setAuthRoutesConfig(defaultRoutesConfig);
    }
    return () => {};
  }, [menus, showAiReviewMenus]);

  // useEffect(() => {
  //   window.location.pathname;
  //   if (userAuthData?.channel?.productSuppliedStatus !== 'COMPLETED') {
  //     navigate('/loading');
  //   }
  // }, [userAuthData]);

  useEffect(() => {
    if (error?.status === 401)
      // 인증 실패시 현재 경로를 쿼리로 전달하여 로그인 페이지로 이동
      (function () {
        try {
          const search = window.location.search || '';
          const pathname = window.location.pathname || '';
          const current = `${pathname}${search}`;
          navigate(`/signin?redirect-url=${encodeURIComponent(current)}`);
        } catch (e) {
          navigate('/signin');
        }
      })();
  }, [error]);

  if (isLoading) return null;

  // return <AppLoader />;

  // console.log('user = ', user);

  // if (
  //   !['/cafe24Auth'].includes(window.location.pathname) &&
  //   user?.channel?.productSuppliedStatus === 'PENDING'
  // )
  //   return <Loading />;

  // if (user)
  const isAuthenticatedLayout =
    isAuthenticated && !['/cafe24Auth', ROUTES.AUTH.SIGNUP_COMPLETE].includes(window.location.pathname);

  return (
    <>
      {isAuthenticatedLayout ? (
        <AppLayout routes={routes} routesConfig={authRoutesConfig} />
      ) : (
        <AppContentView routes={routes} />
      )}
    </>
  );
};

export default Layout;
